import React from 'react';
import Dashboard from './components/Dashboard';
export function App() {
  return <div className="w-full h-screen bg-slate-900 overflow-auto" data-id="element-0">
      <div className="min-w-[1400px] min-h-[900px]" data-id="element-1">
        <Dashboard data-id="element-2" />
      </div>
    </div>;
}